require('expose-loader?BVLazyLoad!../../src/utils/lazy_load');
require('expose-loader?BVWithSuspense!../../src/utils/lazy_load/with_suspense');
